import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CheckBox from '@react/shared-component/CheckBox/View';

import TextFieldInput from '@react/shared-component/TextInput/View';
import OnSearchTextFieldChange from '@react/shared-component/CheckBoxGroup/Service';

/**
 * Displays checkbox lists/group (with search option)
 * @param {object} props - props object
 * @param {element} props.beforeCheckBoxGroup - element to be displayed before checkbox group
 * @param {element} props.afterCheckBoxGroup - element to be displayed after checkbox group
 * @param {boolean} props.enableSearch - enable search option
 * @param {object} props.checkBoxProps - props for single checkbox item
 * @param {array} props.options - array of options to be displayed
 */
function CheckBoxGroup({
	beforeCheckBoxGroup,
	afterCheckBoxGroup,
	enableSearch,
	checkBoxProps,
	options,
	eventCheckBoxChange,
	groupListClassNames,
	...textsearchattributes
}) {
	const [checkBoxOptions, setCheckBoxOptions] = useState(options);

	const renderCheckBoxLists = (allOptions) => {
		if (allOptions.length === 0) {
			return null;
		}

		return allOptions.map((option) => {
			return (
				<CheckBox
					key={option.value}
					option={option}
					checkBoxProps={checkBoxProps}
					eventCheckBoxChange={eventCheckBoxChange}
				/>
			);
		});
	};

	return (
		<>
			{beforeCheckBoxGroup}
			{enableSearch && (
				<TextFieldInput
					onChange={(e) =>
						OnSearchTextFieldChange(e, options, setCheckBoxOptions)
					}
					{...textsearchattributes}
				/>
			)}
			<div className={groupListClassNames}>
				{renderCheckBoxLists(checkBoxOptions)}
			</div>

			{afterCheckBoxGroup}
		</>
	);
}

CheckBoxGroup.propTypes = {
	beforeCheckBoxGroup: PropTypes.element,
	afterCheckBoxGroup: PropTypes.element,
	enableSearch: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
	checkBoxProps: PropTypes.object,
	options: PropTypes.array.isRequired,
	textsearchattributes: PropTypes.object,
	eventCheckBoxChange: PropTypes.func.isRequired,
	groupListClassNames: PropTypes.string,
};

// CheckBoxGroup.defaultProps = {
// 	beforeCheckBoxGroup: null,
// 	afterCheckBoxGroup: null,
// 	enableSearch: false,
// 	checkBoxProps: {},
// 	textsearchattributes: {},
// 	groupListClassNames: '',
// };

export default CheckBoxGroup;
